"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const AccordionContext = react_1.createContext({});
AccordionContext.displayName = 'AccordionContext';
exports.default = AccordionContext;
